import i18next from 'i18next'
import VueI18Next from '@panter/vue-i18next'
import store from '../store'

import custom_pt from '../locales/ptBR/custom'
import common_pt from '../locales/ptBR/common'
import events_pt from '../locales/ptBR/events'
import imports_pt from '../locales/ptBR/imports'
import login_pt from '../locales/ptBR/login'
import feed_pt from '../locales/ptBR/feed'
import not_authenticated_pt from '../locales/ptBR/not_authenticated'
import authenticated_pt from '../locales/ptBR/authenticated'
import admin_pt from '../locales/ptBR/admin'
import library_pt from '../locales/ptBR/library'
import users_pt from '../locales/ptBR/users'
import organization_pt from '../locales/ptBR/organization'
import training_pt from '../locales/ptBR/training'
import trails_pt from '../locales/ptBR/trails'
import tags_pt from '../locales/ptBR/tags'
import news_pt from '../locales/ptBR/news'
import general_tests_pt from '../locales/ptBR/general_tests'
import courses_pt from '../locales/ptBR/courses'
import profile_pt from '../locales/ptBR/profile'
import overview_pt from '../locales/ptBR/overview'
import faq_pt from '../locales/ptBR/faq'
import messages_pt from '../locales/ptBR/messages'
import fortraders_pt from '../locales/ptBR/4traders'
import banners_pt from '../locales/ptBR/banners'
import webcast_pt from '../locales/ptBR/webcast'
import welcome_banners_pt from '../locales/ptBR/welcome_banners'
import survey_pt from '../locales/ptBR/survey'
import presential_pt from '../locales/ptBR/presential'
import podcasts_pt from '../locales/ptBR/podcasts'
import rewards_pt from '../locales/ptBR/rewards'
import discussions_pt from '../locales/ptBR/discussions'
import live_classes_pt from '../locales/ptBR/live_classes'
import games_pt from '../locales/ptBR/games'
import drill_pt from '../locales/ptBR/drill'

import custom_en from '../locales/enUS/custom'
import common_en from '../locales/enUS/common'
import events_en from '../locales/enUS/events'
import imports_en from '../locales/enUS/imports'
import login_en from '../locales/enUS/login'
import feed_en from '../locales/enUS/feed'
import not_authenticated_en from '../locales/enUS/not_authenticated'
import authenticated_en from '../locales/enUS/authenticated'
import admin_en from '../locales/enUS/admin'
import library_en from '../locales/enUS/library'
import users_en from '../locales/enUS/users'
import organization_en from '../locales/enUS/organization'
import training_en from '../locales/enUS/training'
import trails_en from '../locales/enUS/trails'
import tags_en from '../locales/enUS/tags'
import news_en from '../locales/enUS/news'
import general_tests_en from '../locales/enUS/general_tests'
import courses_en from '../locales/enUS/courses'
import profile_en from '../locales/enUS/profile'
import overview_en from '../locales/enUS/overview'
import faq_en from '../locales/enUS/faq'
import messages_en from '../locales/enUS/messages'
import fortraders_en from '../locales/enUS/4traders'
import banners_en from '../locales/enUS/banners'
import webcast_en from '../locales/enUS/webcast'
import welcome_banners_en from '../locales/enUS/welcome_banners'
import survey_en from '../locales/enUS/survey'
import presential_en from '../locales/enUS/presential'
import podcasts_en from '../locales/enUS/podcasts'
import rewards_en from '../locales/enUS/rewards'
import discussions_en from '../locales/enUS/discussions'
import live_classes_en from '../locales/enUS/live_classes'
import games_en from '../locales/enUS/games'
import drill_en from '../locales/enUS/drill'

import custom_es from '../locales/esES/custom'
import common_es from '../locales/esES/common'
import events_es from '../locales/esES/events'
import imports_es from '../locales/esES/imports'
import login_es from '../locales/esES/login'
import feed_es from '../locales/esES/feed'
import not_authenticated_es from '../locales/esES/not_authenticated'
import authenticated_es from '../locales/esES/authenticated'
import admin_es from '../locales/esES/admin'
import library_es from '../locales/esES/library'
import users_es from '../locales/esES/users'
import organization_es from '../locales/esES/organization'
import training_es from '../locales/esES/training'
import trails_es from '../locales/esES/trails'
import tags_es from '../locales/esES/tags'
import news_es from '../locales/esES/news'
import general_tests_es from '../locales/esES/general_tests'
import courses_es from '../locales/esES/courses'
import profile_es from '../locales/esES/profile'
import overview_es from '../locales/esES/overview'
import faq_es from '../locales/esES/faq'
import messages_es from '../locales/esES/messages'
import fortraders_es from '../locales/esES/4traders'
import banners_es from '../locales/esES/banners'
import webcast_es from '../locales/esES/webcast'
import welcome_banners_es from '../locales/esES/welcome_banners'
import survey_es from '../locales/esES/survey'
import presential_es from '../locales/esES/presential'
import podcasts_es from '../locales/esES/podcasts'
import rewards_es from '../locales/esES/rewards'
import discussions_es from '../locales/esES/discussions'
import live_classes_es from '../locales/esES/live_classes'
import games_es from '../locales/esES/games'
import drill_es from '../locales/esES/drill'

import custom_fr from '../locales/frFR/custom'
import common_fr from '../locales/frFR/common'
import events_fr from '../locales/frFR/events'
import imports_fr from '../locales/frFR/imports'
import login_fr from '../locales/frFR/login'
import feed_fr from '../locales/frFR/feed'
import not_authenticated_fr from '../locales/frFR/not_authenticated'
import authenticated_fr from '../locales/frFR/authenticated'
import admin_fr from '../locales/frFR/admin'
import library_fr from '../locales/frFR/library'
import users_fr from '../locales/frFR/users'
import organization_fr from '../locales/frFR/organization'
import training_fr from '../locales/frFR/training'
import trails_fr from '../locales/frFR/trails'
import tags_fr from '../locales/frFR/tags'
import news_fr from '../locales/frFR/news'
import general_tests_fr from '../locales/frFR/general_tests'
import courses_fr from '../locales/frFR/courses'
import profile_fr from '../locales/frFR/profile'
import overview_fr from '../locales/frFR/overview'
import faq_fr from '../locales/frFR/faq'
import messages_fr from '../locales/frFR/messages'
import fortraders_fr from '../locales/frFR/4traders'
import banners_fr from '../locales/frFR/banners'
import webcast_fr from '../locales/frFR/webcast'
import welcome_banners_fr from '../locales/frFR/welcome_banners'
import survey_fr from '../locales/frFR/survey'
import presential_fr from '../locales/frFR/presential'
import podcasts_fr from '../locales/frFR/podcasts'
import rewards_fr from '../locales/frFR/rewards'
import discussions_fr from '../locales/frFR/discussions'
import live_classes_fr from '../locales/frFR/live_classes'
import games_fr from '../locales/frFR/games'
import drill_fr from '../locales/frFR/drill'

import { Quasar } from 'quasar'

export default ({ app, router, Vue }) => {
	Vue.use(VueI18Next)

	i18next.init({
		lng: 'pt',
		resources: {
			pt: {
                admin: admin_pt,
                authenticated: authenticated_pt,
                events: events_pt,
                common: common_pt,
                feed: feed_pt,
                imports: imports_pt,
                login: login_pt,
                not_authenticated: not_authenticated_pt,
                library: library_pt,
                users: users_pt,
                organization: organization_pt,
                training: training_pt,
                trails: trails_pt,
                tags: tags_pt,
                news: news_pt,
                general_tests: general_tests_pt,
                courses: courses_pt,
                profile: profile_pt,
                overview: overview_pt,
                faq: faq_pt,
                messages: messages_pt,
                fortraders: fortraders_pt,
                banners: banners_pt,
                webcast: webcast_pt,
                welcome_banners: welcome_banners_pt,
                survey: survey_pt,
                presential: presential_pt,
                custom: custom_pt,
                podcasts: podcasts_pt,
                rewards: rewards_pt,
                discussions: discussions_pt,
                live_classes: live_classes_pt,
                games: games_pt,
                drill: drill_pt
            },
            en: {
                admin: admin_en,
                authenticated: authenticated_en,
                events: events_en,
                common: common_en,
                feed: feed_en,
                imports: imports_en,
                login: login_en,
                not_authenticated: not_authenticated_en,
                library: library_en,
                users: users_en,
                organization: organization_en,
                training: training_en,
                trails: trails_en,
                tags: tags_en,
                news: news_en,
                general_tests: general_tests_en,
                courses: courses_en,
                profile: profile_en,
                overview: overview_en,
                faq: faq_en,
                messages: messages_en,
                fortraders: fortraders_en,
                banners: banners_en,
                webcast: webcast_en,
                welcome_banners: welcome_banners_en,
                survey: survey_en,
                presential: presential_en,
                custom: custom_en,
                podcasts: podcasts_en,
                rewards: rewards_en,
                discussions: discussions_en,
                live_classes: live_classes_en,
                games: games_en,
                drill: drill_en
            },
            es: {
                admin: admin_es,
                authenticated: authenticated_es,
                events: events_es,
                common: common_es,
                feed: feed_es,
                imports: imports_es,
                login: login_es,
                not_authenticated: not_authenticated_es,
                library: library_es,
                users: users_es,
                organization: organization_es,
                training: training_es,
                trails: trails_es,
                tags: tags_es,
                news: news_es,
                general_tests: general_tests_es,
                courses: courses_es,
                profile: profile_es,
                overview: overview_es,
                faq: faq_es,
                messages: messages_es,
                fortraders: fortraders_es,
                banners: banners_es,
                webcast: webcast_es,
                welcome_banners: welcome_banners_es,
                survey: survey_es,
                presential: presential_es,
                custom: custom_es,
                podcasts: podcasts_es,
                rewards: rewards_es,
                discussions: discussions_es,
                live_classes: live_classes_es,
                games: games_es,
                drill: drill_es
            },
            fr: {
                admin: admin_fr,
                authenticated: authenticated_fr,
                events: events_fr,
                common: common_fr,
                feed: feed_fr,
                imports: imports_fr,
                login: login_fr,
                not_authenticated: not_authenticated_fr,
                library: library_fr,
                users: users_fr,
                organization: organization_fr,
                training: training_fr,
                trails: trails_fr,
                tags: tags_fr,
                news: news_fr,
                general_tests: general_tests_fr,
                courses: courses_fr,
                profile: profile_fr,
                overview: overview_fr,
                faq: faq_fr,
                messages: messages_fr,
                fortraders: fortraders_fr,
                banners: banners_fr,
                webcast: webcast_fr,
                welcome_banners: welcome_banners_fr,
                survey: survey_fr,
                presential: presential_fr,
                custom: custom_fr,
                podcasts: podcasts_fr,
                rewards: rewards_fr,
                discussions: discussions_fr,
                live_classes: live_classes_fr,
                drill: drill_fr
            }
		}
	})

    app.i18n = new VueI18Next(i18next)

    router.beforeEach((to, from, next) => {
        let language = store.getters['params/languages'].find(l => {
            return l.id === store.getters['common/id_user_language_selected']
        })

        if (language) {
            let code = ''

            switch(language.code) {
                case 'es-es': code = language.code.split('-')[0]
                break
                case 'fr-fr': code = language.code.split('-')[0]
                break
                default: code = language.code
                break
            }

            import(`quasar-framework/i18n/${code}`).then(lang => {
                Quasar.i18n.set(lang.default)
            })

            i18next.changeLanguage(language.code.split('-')[0])
        }
        else {
            import('quasar-framework/i18n/pt-br').then(lang => {
                Quasar.i18n.set(lang.default)
            })

            i18next.changeLanguage('pt')
        }

        next()
    })
}
